// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1064":"c6f34b80c18be32e","1954":"911e49ebb39996c3","2217":"726c31f9c7cde7d0","8428":"3fcd7ea8a81bb208"}[chunkId] + ".css";
};